import {
  accountingFormatOptions,
  fixedTwoFractionDigitsCurrencyOptions,
} from 'constants/loanApplication';

// Credit or cost is signed: a cost to the borrower is positive, a lender credit negative. Accounting format is what
// distinguishes them — a cost reads $3,400.00, a credit reads ($3,400.00) — so the parentheses must come from the
// formatter and never be hand-wrapped around the value, which would render a credit as the ambiguous (-$3,400.00).
export const creditOrCostCurrencyOptions = {
  ...fixedTwoFractionDigitsCurrencyOptions,
  ...accountingFormatOptions,
};
